import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VuePortal from '@linusborg/vue-simple-portal'
import App from '@/App'
import router from '@/router'
import store from '@/store'

// Default date & time settings
import { Settings } from 'luxon'
Settings.defaultLocale = 'en-au'
Settings.defaultZoneName = 'Australia/Brisbane'

Vue.use(Vuelidate)
Vue.use(VuePortal)

store.dispatch('auth/init').catch(err => {
	if (err.code === 401) {
		// Handle local user session expiring
		store.commit('auth/logOut')
		store.dispatch('toast/push', {
			message: 'Your session has expired. Please log in again to continue.',
			severity: 'error',
		})
		router.replace('/')
	}
})

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
